export function Form(props: {
  children: React.ReactNode;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
}): React.ReactNode {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit?.(event);
      }}
    >
      {props.children}
    </form>
  );
}
